var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 100 100",
    height: 512,
    viewBox: "0 0 100 100",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_7.Yahoo"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6001d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.479 31.052-9.405 23.242-9.073-23.223c-.266-.681-.922-1.129-1.653-1.129h-12.572c-1.26 0-2.119 1.277-1.643 2.444l16.97 41.654-4.334 10.736c-.471 1.166.388 2.439 1.645 2.439h12.181c.723 0 1.374-.439 1.645-1.109l21.727-53.724c.472-1.166-.387-2.44-1.645-2.44h-12.198c-.723.001-1.374.44-1.645 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.38 13.893c.271-.67.922-1.109 1.645-1.109h12.199c1.258 0 2.117 1.273 1.645 2.44l-12.888 31.746c-.271.67-.922 1.109-1.645 1.109h-12.181c-1.258 0-2.116-1.272-1.645-2.439z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.126,
    cy: 63.355,
    r: 9.854
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.968757bc1ad12b105afc4b89d0363b9a.svg";
export { ForwardRef as ReactComponent };